import React, { Component } from 'react'
import Select from 'react-select-plus';
import { AddNewCallDiv, AvatarDiv, Faq, FaqItem, FaqValue, HeadProfileBar, ItemsFun, ItemsFunItem, ItemsFunValue, TeamDropDown } from '../styles/dialpadstyle';

export class EndCallAgentProfileTheme extends Component {
    render() {
        const { userImg, agentName, onChangeSelect, tagValue, optionsTag, changePwd, changePwdArrow, dashboard, dashboardArrow } = this.props;
        return (
            <span style={{display: 'block', width: '100%'}}>
                <AddNewCallDiv>
                    <HeadProfileBar>
                        <AvatarDiv>
                            <img src={userImg} />
                        </AvatarDiv>
                        <h4>{agentName}</h4>
                    </HeadProfileBar>
                </AddNewCallDiv>
                <TeamDropDown>
                    <Select
                        placeholder="Outbound Team"
                        onChange={onChangeSelect}
                        value={tagValue}
                        options={optionsTag}
                    />
                </TeamDropDown>
                <ItemsFun>
                    <ItemsFunItem>
                        {changePwd}
                    </ItemsFunItem>
                    <ItemsFunValue>
                        <img src="images/arrow-right-dark.svg" onClick={changePwdArrow} />
                    </ItemsFunValue>
                </ItemsFun>
                <ItemsFun>
                    <ItemsFunItem>
                        {dashboard}
                    </ItemsFunItem>
                    <ItemsFunValue>
                        <img src="images/arrow-right-dark.svg" onClick={dashboardArrow} />
                    </ItemsFunValue>
                </ItemsFun>
            </span>
        )
    }
}

export default EndCallAgentProfileTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/EndCallAgentProfileTheme.js